module.exports = __webpack_public_path__ + "img/aq.ad98aeed.svg";